export const isTheme = (theme: string[] | string) => {
  const themes = Array.isArray(theme) ? theme : [theme];
  return themes.map((themeClass) => `.${themeClass} &`).join(',');
};
